import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Form from './contatti/form/Form';
import serviziData from '../data/servizi-data';
import ConsentGatedEmbed from '../gdpr/ConsentGatedEmbed';

function Contact() {
	const { t } = useTranslation();
	const [selectedService, setSelectedService] = useState('');
	const trustItems = t('contact.trustItems', { returnObjects: true });

	return (
		<section
			className="contact-section route"
			id="contact"
		>
			{/* Header */}
			<div className="contact-header">
				<div className="container-modern">
					<div className="contact-header-content">
						<span className="contact-badge">{t('contact.badge')}</span>
						<h2 className="contact-title">
							{t('contact.title')} <span className="text-gradient">{t('contact.titleHighlight')}</span>
						</h2>
						<p className="contact-subtitle">
							{t('contact.subtitle')}
						</p>
					</div>
				</div>
			</div>

			<div className="container-modern">
				{/* Quick Contact Cards */}
				<div className="quick-contacts">
					<a href="tel:0656558610" className="quick-contact-card">
						<div className="quick-contact-icon">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
							</svg>
						</div>
						<div className="quick-contact-info">
							<span className="quick-contact-label">{t('contact.callUs')}</span>
							<span className="quick-contact-value">+39 06 5655 8610</span>
						</div>
						<span className="quick-contact-arrow">&rarr;</span>
					</a>

					<a href="mailto:info@ingegneriabernasconi.it" className="quick-contact-card">
						<div className="quick-contact-icon">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
								<polyline points="22,6 12,13 2,6"/>
							</svg>
						</div>
						<div className="quick-contact-info">
							<span className="quick-contact-label">{t('contact.writeUs')}</span>
							<span className="quick-contact-value">info@ingegneriabernasconi.it</span>
						</div>
						<span className="quick-contact-arrow">&rarr;</span>
					</a>

					<a href="https://goo.gl/maps/73tgAzyVzJpsbh6b6" target="_blank" rel="noopener noreferrer" className="quick-contact-card">
						<div className="quick-contact-icon">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
								<circle cx="12" cy="10" r="3"/>
							</svg>
						</div>
						<div className="quick-contact-info">
							<span className="quick-contact-label">{t('contact.visitUs')}</span>
							<span className="quick-contact-value">{t('contact.address')}</span>
						</div>
						<span className="quick-contact-arrow">&rarr;</span>
					</a>
				</div>

				{/* Main Content: Form + Info */}
				<div className="contact-grid">
					{/* Left: Form */}
					<div className="contact-form-wrapper">
						<div className="contact-form-card">
							<h3 className="contact-form-title">{t('contact.formTitle')}</h3>
							<p className="contact-form-desc">
								{t('contact.formDesc')}
							</p>

							{/* Service Selector */}
							<div className="service-selector">
								<label className="service-selector-label">{t('contact.serviceLabel')}</label>
								<div className="service-chips">
									{serviziData.map((servizio) => (
										<button
											key={servizio.id}
											type="button"
											className={`service-chip ${selectedService === servizio.id ? 'service-chip-active' : ''}`}
											onClick={() => setSelectedService(selectedService === servizio.id ? '' : servizio.id)}
										>
											{t(`contact.serviceChips.${servizio.id}`)}
										</button>
									))}
								</div>
							</div>

							<Form selectedService={selectedService} />
						</div>
					</div>

					{/* Right: Map + Trust */}
					<div className="contact-info-wrapper">
						{/* Map */}
						<div className="contact-map-card">
							<ConsentGatedEmbed
								className="contact-map"
								title={t('contact.mapTitle')}
								src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11879.4310083316!2d12.4760295!3d41.8959162!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf7ffb6b6e3858bcf!2sIng.%20Eleonora%20Bernasconi%20Studio%20di%20Ingegneria%20dell&#39;Informazione%20-%20Information%20and%20Communication%20Technology!5e0!3m2!1sit!2sit!4v1592643040506!5m2!1sit!2sit"
								category="marketing"
								placeholderText={t('contact.mapConsent')}
							/>
						</div>

						{/* Trust Signals */}
						<div className="trust-card">
							<h4 className="trust-title">{t('contact.whyUs')}</h4>
							<div className="trust-items">
								<div className="trust-item">
									<div className="trust-icon">
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
											<polyline points="22 4 12 14.01 9 11.01"/>
										</svg>
									</div>
									<div>
										<strong>{trustItems[0]?.title}</strong>
										<p>{trustItems[0]?.desc}</p>
									</div>
								</div>
								<div className="trust-item">
									<div className="trust-icon">
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<circle cx="12" cy="12" r="10"/>
											<polyline points="12 6 12 12 16 14"/>
										</svg>
									</div>
									<div>
										<strong>{trustItems[1]?.title}</strong>
										<p>{trustItems[1]?.desc}</p>
									</div>
								</div>
								<div className="trust-item">
									<div className="trust-icon">
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4-4v2"/>
											<circle cx="9" cy="7" r="4"/>
											<path d="M23 21v-2a4 4 0 00-3-3.87"/>
											<path d="M16 3.13a4 4 0 010 7.75"/>
										</svg>
									</div>
									<div>
										<strong>{trustItems[2]?.title}</strong>
										<p>{trustItems[2]?.desc}</p>
									</div>
								</div>
								<div className="trust-item">
									<div className="trust-icon">
										<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
											<path d="M7 11V7a5 5 0 0110 0v4"/>
										</svg>
									</div>
									<div>
										<strong>{trustItems[3]?.title}</strong>
										<p>{trustItems[3]?.desc}</p>
									</div>
								</div>
							</div>
						</div>

						{/* Social */}
						<div className="contact-social-card">
							<span className="contact-social-label">{t('contact.followUs')}</span>
							<div className="contact-social-links">
								<a
									href="https://www.linkedin.com/company/ing-eleonora-bernasconi-studio-di-ingegneria/"
									target="_blank"
									rel="noopener noreferrer"
									className="contact-social-link"
									aria-label="LinkedIn"
								>
									<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
										<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
									</svg>
								</a>
								<a
									href="https://www.instagram.com/ingegneriabernasconi"
									target="_blank"
									rel="noopener noreferrer"
									className="contact-social-link"
									aria-label="Instagram"
								>
									<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
										<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
									</svg>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

		</section>
	);
}

export default Contact;
